import { styled } from '@components-shared/src/stitches';

export const GridElem = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginBottom: '25px',
});
